// extracted by mini-css-extract-plugin
export default {"headCard":"chaptersPage_headCard__Wmvg5","cardCustom":"chaptersPage_cardCustom__AGWxX","cardBodyCustom":"chaptersPage_cardBodyCustom__0pgRR"};